import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { SparkleIcon } from './Icons';
export function VisionSection() {
  const points = [{
    emoji: '🌙',
    text: 'Tu hijo escuchando una historia llena de luz antes de dormir… mientras su mente se calma y su corazón encuentra paz.'
  }, {
    emoji: '✨',
    text: 'Cada cuento sembrando enseñanzas de amor, bondad, fe y protección espiritual de una manera suave y natural.'
  }, {
    emoji: '👨‍👩‍👧',
    text: 'Noches más especiales, con abrazos, conexión familiar y momentos que quedarán en la memoria.'
  }, {
    emoji: '💖',
    text: 'Niños creciendo con más tranquilidad, sensibilidad, empatía y confianza espiritual.'
  }, {
    emoji: '🌟',
    text: 'Y la hora de dormir transformándose en un ritual mucho más sereno, amoroso y reconfortante.'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-indigo relative overflow-hidden" data-id="element-220">
      {/* Decorative stars */}
      <div className="absolute top-10 left-1/4 text-gold/20" data-id="element-221">
        <SparkleIcon className="w-8 h-8" data-id="element-222" />
      </div>
      <div className="absolute bottom-20 right-1/4 text-gold/20" data-id="element-223">
        <SparkleIcon className="w-12 h-12" data-id="element-224" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-226">
          <h2 className="text-4xl md:text-5xl font-serif font-medium text-cream mb-6" data-id="element-227">
            Ahora imagina este momento…
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-228">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-6 bg-indigo-light/50 p-6 rounded-2xl backdrop-blur-sm" data-id="element-229">
              <span className="text-3xl shrink-0" data-id="element-230">{point.emoji}</span>
              <p className="text-cream/90 text-lg md:text-xl leading-relaxed" data-id="element-231">
                {point.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}